<div #footer>
    <footer clientSideOnly *ngIf="isDataReady" class="flex flex-col bg-[#ECECEE] w-f"
        [ngStyle]="pageType === 'woqod' ? {'background': 'linear-gradient(to right top, #051937, #003960, #005b72, #007c62, #009933)'} : pageType === 'qjet' ? {'background': '#ECECEE' , 'opacity':'0.9'} : {'background': '#ECECEE'}">
        <div
            class="max-w-desktop-less flex flex-col lg:flex-row gap-16 xl:gap-32 pt-16 lg:pt-[4rem]  mx-auto w-full px-4 xl:px-0">
            <div class="w-full flex flex-col gap-12 lg:gap-[42px] flex-1" *ngIf="pageType && lang">
                <div *ngFor="let topMenuContainer of topMenu?.[pageType]?.[lang]; let i = index"
                    class="flex flex-col lg:flex-row flex-wrap justify-center lg:justify-between gap-12 main-menu">
                    <div class="flex flex-col w-full lg:w-[168px]" [class.notFirstCol]="i > 0">
                        <div *ngIf="i === 0">
                            <div>
                                <div class="w-full text-center lg:ltr:text-left lg:w-[140px]">
                                    <a class="flex justify-center" aria-label="woqod logo link to home page"
                                        [routerLink]="'/' | routeLocalization">
                                        <app-svg class="inline-block"
                                            [ngClass]="pageType === 'woqod' ? 'w-[73px] h-[102px]' : pageType === 'qjet' ? 'w-[95px] h-[157px]' : 'w-[95px] h-[157px]'"
                                            [src]="pageType === 'woqod' ? 'assets/svgs/woqood-footer-logo-n.svg' : pageType === 'qjet' ? 'assets/svgs/fahes-footer-logo.svg' : 'assets/svgs/fahes-footer-logo.svg'"
                                            customClass="" label="title_goas_here" [stretch]="false" fill="#fff"
                                            [width]="pageType === 'woqod' ? '73' : pageType === 'qjet' ? '95' : '95'"
                                            [height]="pageType === 'woqod' ? '102' : pageType === 'qjet' ? '157' : '157'"></app-svg>
                                    </a>
                                    <p
                                        [ngClass]="pageType === 'woqod' ? 'text-[#FFF]' : pageType === 'qjet' ? 'text-[#011C35]' : 'text-[#011C35]'"
                                        class="mt-4  mb-5 text-center tracking-[-0.32px] font-Poppins-Light text-sm ">
                                        {{ 'FOOTER.COPY_RIGHT_WITHOUT_YEAR' | translate: { pageType: pageType === 'woqod' ? lang ==='en' ? 'WOQOD' : 'وقود' : pageType === 'qjet' ? lang ==='en' ? 'QJET' : 'كيوجت' : lang ==='en' ? 'FAHES' : 'فاحص' }
                                        }}
                                        
                                    </p>
                                    <ul class="flex flex-row gap-1 justify-center flex-wrap">
                                        <li *ngFor="let socialLink of socialLinks"
                                            class="flex justify-center items-center">
                                            <a [href]="socialLink.href | routeLocalization" target="_blank"
                                                aria-label="woqod social link"
                                                class="flex justify-center items-center w-5 h-5">
                                                <img [src]="socialLink.icon | imageSource" class="" alt="" width="12"
                                                    height="12" />
                                                    
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div class="lg:hidden">
                                <div class="w-full text-center lg:ltr:text-left lg:w-[140px]">
                                    <div class="flex flex-col gap-5 w-full justify-center pt-[40px] lg:pt-0">
                                        <div *ngFor="let item of woqoodApp"
                                            class="flex flex-row lg:flex-col gap-4 justify-center items-center">
                                            <a [href]="item?.urlOne | routeLocalization"
                                                aria-label="more about this app image">
                                                <img class="max-w-[143px] h-[44px] w-auto" width="" height="55"
                                                    [src]="item?.imgOne | imageSource" alt="">
                                            </a>
                                            <a [href]="item?.urlTwo | routeLocalization"
                                                aria-label="more about this app image">
                                                <img class="max-w-[143px] h-[44px] w-auto" width="" height="55"
                                                    [src]="item?.imgTwo | imageSource" alt="">
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="i === 1">
                            <div class="w-full text-center lg:ltr:text-left lg:w-[140px]">
                                <div class="flex flex-col gap-5 w-full justify-center pt-[40px] lg:pt-0">
                                    <div *ngFor="let item of woqoodApp"
                                        class="flex flex-row lg:flex-col gap-4 justify-center items-center">
                                        <a [href]="item?.urlOne | routeLocalization"
                                            aria-label="more about this app image">
                                            <img class="max-w-[143px] h-[44px] w-auto" width="" height="55"
                                                [src]="item?.imgOne | imageSource" alt="">
                                        </a>
                                        <a [href]="item?.urlTwo | routeLocalization"
                                            aria-label="more about this app image">
                                            <img class="max-w-[143px] h-[44px] w-auto" width="" height="55"
                                                [src]="item?.imgTwo | imageSource" alt="">
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="item-order flex flex-col gap-6 relative before:absolute before:content-normal before:w-full lg:before:w-px before:h-px lg:before:h-[calc(100%-48px)] before:-top-6 lg:before:top-12 before:bg-black before:opacity-10 ltr:before:left-0 ltr:lg:before:-left-8 rtl:before:right-0 rtl:lg:before:-right-8 lg:first:before:hidden w-full lg:w-[calc((100%/4)-32px)]"
                        *ngFor="let topMenuContainerItem of topMenuContainer">

                        <ng-container *ngIf="isExternalMethod(topMenuContainerItem.link)">

                            <a *ngIf="topMenuContainerItem.target === '_blank'" target="_blank"
                                [href]="topMenuContainerItem.link | routeLocalization"
                                [ngClass]="pageType === 'woqod' ? 'text-[#FFF]' : pageType === 'qjet' ? 'text-[#011C35] font-[600] hover:font-[650]' : 'text-[#011C35] font-[600] hover:font-[650]'"
                                class="ltr:text-left rtl:text-right tracking-[-0.57px] font-Poppins-Medium text-base hover:font-[450]">
                                <span [innerHTML]="topMenuContainerItem.title | htmlSanitizer"></span>
                                <span
                                    class="absolute ltr:left-[-9999px] rtl:right-[-9999px] w-px h-px overflow-hidden">Read
                                    more about
                                    this button</span>
                            </a>


                            <a *ngIf="topMenuContainerItem.target !== '_blank'"
                                [href]="topMenuContainerItem.link | routeLocalization"
                                [ngClass]="pageType === 'woqod' ? 'text-[#FFF]' : pageType === 'qjet' ? 'text-[#011C35] font-[600] hover:font-[650]' : 'text-[#011C35] font-[600] hover:font-[650]'"
                                class="ltr:text-left rtl:text-right tracking-[-0.57px] font-Poppins-Medium text-base hover:font-[450]">
                                <span [innerHTML]="topMenuContainerItem.title | htmlSanitizer"></span>
                                <span
                                    class="absolute ltr:left-[-9999px] rtl:right-[-9999px] w-px h-px overflow-hidden">Read
                                    more about
                                    this button</span>
                            </a>

                        </ng-container>


                        <ng-container *ngIf="!isExternalMethod(topMenuContainerItem.link)">

                            <a *ngIf="topMenuContainerItem.target === '_blank'" target="_blank"
                                [href]="topMenuContainerItem.link | routeLocalization"
                                [ngClass]="pageType === 'woqod' ? 'text-[#FFF]' : pageType === 'qjet' ? 'text-[#011C35] font-[600] hover:font-[650]' : 'text-[#011C35] font-[600] hover:font-[650]'"
                                class="ltr:text-left rtl:text-right tracking-[-0.57px] font-Poppins-Medium text-base hover:font-[450]">
                                <span [innerHTML]="topMenuContainerItem.title | htmlSanitizer"></span>
                                <span
                                    class="absolute ltr:left-[-9999px] rtl:right-[-9999px] w-px h-px overflow-hidden">Read
                                    more about
                                    this button</span>
                            </a>


                            <a *ngIf="topMenuContainerItem.target !== '_blank'"
                                [routerLink]="topMenuContainerItem.link | routeLocalization"
                                [ngClass]="pageType === 'woqod' ? 'text-[#FFF]' : pageType === 'qjet' ? 'text-[#011C35] font-[600] hover:font-[650]' :'text-[#011C35] font-[600] hover:font-[650]'"
                                class="ltr:text-left rtl:text-right tracking-[-0.57px] font-Poppins-Medium text-base hover:font-[450]">
                                <span [innerHTML]="topMenuContainerItem.title | htmlSanitizer"></span>
                                <span
                                    class="absolute ltr:left-[-9999px] rtl:right-[-9999px] w-px h-px overflow-hidden">Read
                                    more about
                                    this button</span>
                            </a>

                        </ng-container>


                        <div class="flex flex-col lg:flex-row gap-2.5 lg:gap-6">
                            <div class="w-full lg:w-1/2 flex flex-row gap-[52px] flex-1 left-side-footer"
                                *ngFor="let innerList of topMenuContainerItem.list; let i = index">
                            <div *ngFor="let subList of innerList; let i = index" class="w-full"
                             [class.two-items]="subList.length > 1"
                             >
                                <ul *ngFor="let group of subList"
                                    class="flex flex-col gap-2.5 w-full">
                                    <li *ngFor="let innerListItem of group" class="">


                                        <ng-container *ngIf="isExternalMethod(topMenuContainerItem.link)">

                                            <a *ngIf="innerListItem.target === '_blank'" target="_blank"
                                                [href]="innerListItem.link | routeLocalization">
                                                
                                                <span [innerHTML]="innerListItem.title | htmlSanitizer"
                                                [ngClass]="pageType === 'woqod' ? 'text-[#FFF]' : pageType === 'qjet' ? 'text-[#011C35]' : 'text-[#011C35]'"
                                                    class="ltr:text-left rtl:text-right tracking-[-0.39px]  font-Poppins-Light text-sm leading-[26px] hover:font-[450]"></span>
                                                <span
                                                    class="absolute ltr:left-[-9999px] rtl:right-[-9999px] w-px h-px overflow-hidden">Read
                                                    more about
                                                    this button</span>
                                            </a>


                                            <a *ngIf="innerListItem.target !== '_blank'"
                                                [href]="innerListItem.link | routeLocalization">
                                                <span [innerHTML]="innerListItem.title | htmlSanitizer"
                                                [ngClass]="pageType === 'woqod' ? 'text-[#FFF]' : pageType === 'qjet' ? 'text-[#011C35]' : 'text-[#011C35]'"
                                                    class="ltr:text-left rtl:text-right tracking-[-0.39px] font-Poppins-Light text-sm leading-[26px] hover:font-[450]"></span>
                                                <span
                                                    class="absolute ltr:left-[-9999px] rtl:right-[-9999px] w-px h-px overflow-hidden">Read
                                                    more about
                                                    this button</span>
                                            </a>

                                        </ng-container>


                                        <ng-container *ngIf="!isExternalMethod(topMenuContainerItem.link)">

                                            <a *ngIf="innerListItem.target === '_blank'" target="_blank"
                                                [href]="baseURL() + (innerListItem.link | routeLocalization)">
                                                <span [innerHTML]="innerListItem.title | htmlSanitizer"
[ngClass]="pageType === 'woqod' ? 'text-[#FFF]' : pageType === 'qjet' ? 'text-[#011C35]' : 'text-[#011C35]'"
                                                    class="ltr:text-left rtl:text-right tracking-[-0.39px]  font-Poppins-Light text-sm leading-[26px] hover:font-[450]"></span>
                                                <span
                                                    class="absolute ltr:left-[-9999px] rtl:right-[-9999px] w-px h-px overflow-hidden">Read
                                                    more about
                                                    this button</span>
                                            </a>


                                            <a *ngIf="innerListItem.target !== '_blank'"
                                                [routerLink]="innerListItem.link | routeLocalization">
                                                <span [innerHTML]="innerListItem.title | htmlSanitizer"
[ngClass]="pageType === 'woqod' ? 'text-[#FFF]' : pageType === 'qjet' ? 'text-[#011C35]' : 'text-[#011C35]'"
                                                    class="ltr:text-left rtl:text-right tracking-[-0.39px]  font-Poppins-Light text-sm leading-[26px] hover:font-[450]"></span>
                                                <span
                                                    class="absolute ltr:left-[-9999px] rtl:right-[-9999px] w-px h-px overflow-hidden">Read
                                                    more about
                                                    this button</span>
                                            </a>

                                        </ng-container>


                                    </li>
                                </ul>
                                </div>
                            </div>

                            <!-- <ng-container *ngIf="topMenuContainerItem?.list?.[0]?.[0]?.length > 6">
                                <div class="w-full lg:w-1/2 flex flex-row gap-[52px] right-side-footer"
                                    *ngFor="let innerList of topMenuContainerItem.list; let i = index">
                                    <ul *ngFor="let subList of innerList; let i = index "
                                        class="flex flex-col gap-2.5 w-auto"
                                        [class]="{'lg:w-[150px]': i === 0 && innerList.length >= 1 }">
                                        <li *ngFor="let innerListItem of subList" class="right-side-footer-item">


                                            <ng-container *ngIf="isExternalMethod(topMenuContainerItem.link)">

                                                <a *ngIf="innerListItem.target === '_blank'" target="_blank"
                                                    [href]="innerListItem.link | routeLocalization">
                                                    <span [innerHTML]="innerListItem.title | htmlSanitizer"
[ngClass]="pageType === 'woqod' ? 'text-[#FFF]' : pageType === 'qjet' ? 'text-[#011C35]' : 'text-[#011C35]'"
                                                        class="ltr:text-left rtl:text-right tracking-[-0.39px]  font-Poppins-Light text-sm leading-[26px] hover:font-[450]"></span>
                                                    <span
                                                        class="absolute ltr:left-[-9999px] rtl:right-[-9999px] w-px h-px overflow-hidden">Read
                                                        more about
                                                        this button</span>
                                                </a>


                                                <a *ngIf="innerListItem.target !== '_blank'"
                                                    [href]="innerListItem.link | routeLocalization">
                                                    <span [innerHTML]="innerListItem.title | htmlSanitizer"
[ngClass]="pageType === 'woqod' ? 'text-[#FFF]' : pageType === 'qjet' ? 'text-[#011C35]' : 'text-[#011C35]'"
                                                        class="ltr:text-left rtl:text-right tracking-[-0.39px] font-Poppins-Light text-sm leading-[26px] hover:font-[450]"></span>
                                                    <span
                                                        class="absolute ltr:left-[-9999px] rtl:right-[-9999px] w-px h-px overflow-hidden">Read
                                                        more about
                                                        this button</span>
                                                </a>

                                            </ng-container>


                                            <ng-container *ngIf="!isExternalMethod(topMenuContainerItem.link)">

                                                <a *ngIf="innerListItem.target === '_blank'" target="_blank"
                                                    [href]="baseURL() + (innerListItem.link | routeLocalization)">
                                                    <span [innerHTML]="innerListItem.title | htmlSanitizer"
[ngClass]="pageType === 'woqod' ? 'text-[#FFF]' : pageType === 'qjet' ? 'text-[#011C35]' : 'text-[#011C35]'"
                                                        class="ltr:text-left rtl:text-right tracking-[-0.39px] font-Poppins-Light text-sm leading-[26px] hover:font-[450]"></span>
                                                    <span
                                                        class="absolute ltr:left-[-9999px] rtl:right-[-9999px] w-px h-px overflow-hidden">Read
                                                        more about
                                                        this button</span>
                                                </a>


                                                <a *ngIf="innerListItem.target !== '_blank'"
                                                    [routerLink]="innerListItem.link | routeLocalization">
                                                    <span [innerHTML]="innerListItem.title | htmlSanitizer"
[ngClass]="pageType === 'woqod' ? 'text-[#FFF]' : pageType === 'qjet' ? 'text-[#011C35]' : 'text-[#011C35]'"
                                                        class="ltr:text-left rtl:text-right tracking-[-0.39px] font-Poppins-Light text-sm leading-[26px] hover:font-[450]"></span>
                                                    <span
                                                        class="absolute ltr:left-[-9999px] rtl:right-[-9999px] w-px h-px overflow-hidden">Read
                                                        more about
                                                        this button</span>
                                                </a>

                                            </ng-container>

                                        </li>
                                    </ul>
                                </div>
                            </ng-container> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="pt-[28px] lg:pt-[75px] pb-8 max-w-desktop-less mx-auto w-full px-4 lg:px-0 relative">
            <hr [ngClass]="pageType === 'woqod' ? 'border-[#FFF]' : pageType === 'qjet' ? 'border-[#011C35]' : 'border-[#011C35]'" class="border-t-0 border-l-0 border-r-0 border-b-2  opacity-30">
            <button type="button" class="scroll-top-button" [ngClass]="pageType" (click)="scrollTop($event)"
                id="sroll_to_top" aria-label="scroll page to top">
                <app-svg src="assets/svgs/arrow.svg" customClass="rotate-180" label="scroll page to top"
                    [stretch]="false" width="35" height="35" stroke="#ffffff"></app-svg>
            </button>
        </div>
        <div class="max-w-desktop-less flex flex-col lg:flex-row gap-12 lg:gap-32 mx-auto w-full px-4 xl:px-0 pb-6">
            <p
            [ngClass]="pageType === 'woqod' ? 'text-[#FFF]' : pageType === 'qjet' ? 'text-[#011C35]' : 'text-[#011C35]'"
                class="ltr:text-left rtl:text-right tracking-[-0.32px]  font-Poppins-Light text-sm order-2 lg:order-1">
                {{ 'FOOTER.COPY_RIGHT_WITH_YEAR' | translate: { cYear: cYear, pageType: pageType === 'woqod' ? lang ==='en' ? 'WOQOD' :'وقود': pageType === 'qjet' ? lang ==='en' ?'QJET' : 'كيوجت' : lang ==='en' ? 'FAHES': 'فاحص' } }}
            </p>
            <ul class="flex flex-col lg:flex-row flex-wrap gap-2.5 lg:gap-[26px] flex-1 justify-end order-1 lg:order-2"
                *ngIf="pageType && lang">
                <li *ngFor="let bottomMenuItem of bottomMenu?.[pageType]?.[lang]">


                    <ng-container *ngIf="isExternalMethod(bottomMenuItem.link)">

                        <a *ngIf="bottomMenuItem.target === '_blank'" target="_blank"
                            [href]="baseURL() + (bottomMenuItem.link | routeLocalization)">
                            <span [innerHTML]="bottomMenuItem.title | htmlSanitizer"
                            [ngClass]="pageType === 'woqod' ? 'text-[#FFF]' : pageType === 'qjet' ? 'text-[#011C35]' : 'text-[#011C35]'"
                                class="ltr:text-left rtl:text-right tracking-[-0.5px] font-Poppins-Light text-sm hover:font-[450]"></span>
                            <span class="absolute ltr:left-[-9999px] rtl:right-[-9999px] w-px h-px overflow-hidden">Read
                                more about
                                this button</span>
                        </a>


                        <a *ngIf="bottomMenuItem.target !== '_blank'" [href]="bottomMenuItem.link | routeLocalization">
                            <span [innerHTML]="bottomMenuItem.title[lang] | htmlSanitizer"
[ngClass]="pageType === 'woqod' ? 'text-[#FFF]' : pageType === 'qjet' ? 'text-[#011C35]' : 'text-[#011C35]'"
                                class="ltr:text-left rtl:text-right tracking-[-0.5px] font-Poppins-Light text-sm hover:font-[450]"></span>
                            <span class="absolute ltr:left-[-9999px] rtl:right-[-9999px] w-px h-px overflow-hidden">Read
                                more about
                                this button</span>
                        </a>

                    </ng-container>


                    <ng-container *ngIf="!isExternalMethod(bottomMenuItem.link)">

                        <a *ngIf="bottomMenuItem.target === '_blank'" target="_blank"
                            [href]="bottomMenuItem.link | routeLocalization">
                            <span [innerHTML]="bottomMenuItem.title[lang] | htmlSanitizer"
[ngClass]="pageType === 'woqod' ? 'text-[#FFF]' : pageType === 'qjet' ? 'text-[#011C35]' : 'text-[#011C35]'"
                                class="ltr:text-left rtl:text-right tracking-[-0.5px] font-Poppins-Light text-sm hover:font-[450]"></span>
                            <span class="absolute ltr:left-[-9999px] rtl:right-[-9999px] w-px h-px overflow-hidden">Read
                                more about
                                this button</span>
                        </a>


                        <a *ngIf="bottomMenuItem.target !== '_blank'"
                            [routerLink]="bottomMenuItem.link | routeLocalization">
                            <span [innerHTML]="bottomMenuItem.title[lang] | htmlSanitizer"
[ngClass]="pageType === 'woqod' ? 'text-[#FFF]' : pageType === 'qjet' ? 'text-[#011C35]' : 'text-[#011C35]'"
                                class="ltr:text-left rtl:text-right tracking-[-0.5px] font-Poppins-Light text-sm hover:font-[450]"></span>
                            <span class="absolute ltr:left-[-9999px] rtl:right-[-9999px] w-px h-px overflow-hidden">Read
                                more about
                                this button</span>
                        </a>

                    </ng-container>

                </li>
            </ul>
        </div>
    </footer>
</div>